import { z } from "zod";

/**
 * Register a deployed Vibe app as a CUSTOM_MANIFEST agent tool — the
 * session-authed console path (the same bridge as the public-v1 api-key
 * endpoint). The tool's endpoint is the app's server-owned canonical URL, so
 * it is never in the body; per-app edge auth is injected server-side, so the
 * console never sends credentials. The caller supplies the OpenAPI spec that
 * describes the app's HTTP surface.
 */

export const VibeRegisterAsToolPathVarsSchema = z.object({
  id: z.string().uuid()
});

export const VibeRegisterAsToolBodySchema = z.object({
  /// The app's OpenAPI spec (JSON or YAML) as a string. Parsed into tool
  /// actions server-side, exactly like a generic external-tool create.
  openApiSpec: z.string().min(1, "OpenAPI spec is required"),
  /// Optional override of the registered tool's public name / description.
  /// Default: the app's own name and a generated description.
  name: z.string().trim().min(1).max(200).optional(),
  description: z.string().max(2000).optional()
});

/**
 * Slim summary of the tool created from the app — enough for the console to
 * confirm the registration and link to the tool. The app's `linkedToolId` is
 * what actually gates re-registration.
 */
export const VibeRegisteredToolSchema = z.object({
  id: z.string(),
  name: z.string(),
  endpointUrl: z.string().nullable(),
  actionsCount: z.number(),
  authType: z.string(),
  createdAt: z.coerce.date()
});

export type VibeRegisteredToolDto = z.infer<typeof VibeRegisteredToolSchema>;

export const VibeRegisterAsToolResponseSchema = z.object({
  tool: VibeRegisteredToolSchema
});
